import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

import {Subscription} from 'rxjs';
import {LoginFormState} from '../login-form-state.enum';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmDialogService} from '../../../services/confirm-dialog-service/confirm-dialog.service';
import {AuthenticationService} from '../../../services/auth/authentication.service';
import {CordovaService} from '../../../services/cordova.service';
import {Utils} from '../../../utils.class';
import {Routenames} from '../../../routenames';
import {LocalStorage} from '../../../utils/storage';
import {Title} from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';


@Component({
    selector: 'app-link-login',
    templateUrl: './link-login.component.html',
    styleUrls: ['./link-login.component.scss'],
})
export class LinkLoginComponent implements OnInit, OnDestroy {

    LoginFormState = LoginFormState;

    loginFormState: LoginFormState = LoginFormState.FillIn;
    errorMessage = null;
    subscriptions = new Subscription();
    paramToken = null;
    tokenData: { name?: string } = null;

    loginForm = new UntypedFormGroup({
        email: new UntypedFormControl(AuthenticationService.filledInEmail, [Validators.required, Validators.email]),
        code: new UntypedFormControl('')
    });

    isIos: boolean;

    constructor(private confirmDialog: ConfirmDialogService,
                private authService: AuthenticationService,
                private router: Router,
                private cordovaSerice: CordovaService,
                private route: ActivatedRoute,
                private title: Title,
                private platformService: Platform
            ) {
                this.isIos = platformService.IOS;
    }

    ngOnInit() {
        this.title.setTitle('Inloggen - TSNed App');
        this.cordovaSerice.setBackbuttonExitAction();
        this.subscriptions.add(this.route.params.subscribe(params => {
            if (params['token']) {
                this.paramToken = params['token'];
                this.tokenData = Utils.getJwtData(this.paramToken);
            }
        }));

        this.subscriptions.add(this.loginForm.get('email').valueChanges.subscribe((val: string) => {
            if (val.indexOf(' ') !== -1) {
                this.loginForm.get('email').setValue(val.replace(' ', ''));
            }
        }));
    }

    pasteCode(event: ClipboardEvent) {
        // @ts-ignore
        const clipboardData = event.clipboardData || window.clipboardData;
        const pastedText = clipboardData.getData('text').replace(/\D/g, '');
        this.loginForm.controls['code'].setValue(pastedText);
        return false;
    }

    loginParamToken() {
        this.loginFormState = LoginFormState.Login;
        this.authService.logout();
        this.authService.refresh(this.paramToken, true).subscribe(() => {
            this.router.navigateByUrl('/');
        }, () => {
            this.loginFormState = LoginFormState.Error;
            if (LocalStorage.userToken) {
                this.authService.refresh(null, true).subscribe(() => {
                    this.router.navigateByUrl('/');
                }, () => {
                    this.loginFormState = LoginFormState.Error;
                    this.invalidToken();
                });
            } else {
                this.invalidToken();
            }
        });
    }

    invalidToken() {
        this.confirmDialog.confirm(
            'Ongeldige link',
            'De gebruikte links is niet (meer) geldig.',
            'Sluiten',
            null
        ).then(() => {
            this.router.navigate([Routenames.Login]);
        }, () => {

        });
    }

    ngOnDestroy() {
        AuthenticationService.filledInEmail = this.loginForm.get('email').value;
        this.subscriptions.unsubscribe();
    }

    login() {
        Utils.triggerValidation(this.loginForm);
        if (this.loginForm.valid) {
            this.errorMessage = null;
            this.loginFormState = LoginFormState.Login;

            if(this.platformService.IOS){
                this.authService.loginCode(this.loginForm.value.email).subscribe(
                    {
                        next: () =>{
                            this.loginFormState = LoginFormState.Send;
                            this.authService.setRedirect('/')
                        },
                        error: (err) => {
                            this.loginFormState = LoginFormState.FillIn;
                        },
                    }
                );
            } else {
                this.authService.loginEmail(this.loginForm.value.email).subscribe(
                    {
                        next: () =>{
                            this.loginFormState = LoginFormState.Send;
                            this.authService.setRedirect('/')
                        },
                        error: (err) => {
                            this.loginFormState = LoginFormState.FillIn;
                        },
                    }
                );
            }
        }
    }

    forgotPassword() {
        this.router.navigate(['wachtwoord-vergeten']);
        return false;
    }

    validateCode() {
        if (this.loginFormState !== LoginFormState.ValidatingPin) {
            this.errorMessage = null;
            this.loginFormState = LoginFormState.ValidatingPin;

            this.subscriptions.add(
                this.authService.validateCode(this.loginForm.value.email, this.loginForm.value.code).subscribe({
                    next: (authResponse) => {
                        if (authResponse?.redirect) {
                            this.router.navigateByUrl(authResponse.redirect);
                        }
                    },
                    error: () => {
                        this.confirmDialog.confirm('Code is onjuist', 'Je hebt een onjuiste code ingevoerd. Probeer het opnieuw.', 'Oké', null);
                        this.loginFormState = LoginFormState.Send;
                    },
                })
            );
        }
    }
}
